import { render, staticRenderFns } from "./basicConfig.vue?vue&type=template&id=38cbeaeb&"
import script from "./basicConfig.vue?vue&type=script&lang=js&"
export * from "./basicConfig.vue?vue&type=script&lang=js&"
import style0 from "./basicConfig.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports